export var TableQueryType;
(function (TableQueryType) {
    TableQueryType[TableQueryType["Folder"] = 0] = "Folder";
    TableQueryType[TableQueryType["Search"] = 1] = "Search";
    TableQueryType[TableQueryType["Group"] = 2] = "Group";
})(TableQueryType || (TableQueryType = {}));
//# sourceMappingURL=TableQuery.js.map